<template>
  <!-- GÖR OM TILL SLUG -->
  <router-link class="article-atom" :class="{ 'related-article': relatedArticle }" :to="'/article/' + article.id">
    <div class="article-atom__article-box">
      <img :src="article.image" />
      <div>
        <h2 class="article-atom__article-box__title">{{ article.title }}</h2>
      </div>

      <div v-if="existsAndIsNotEmpty(article.author.name) || existsAndIsNotEmpty(article.author.title)" class="article-atom__article-box__name">
        <p>
          <span>{{ article.author.name }}</span>
          <span v-if="existsAndIsNotEmpty(article.author.name) && existsAndIsNotEmpty(article.author.title)">, </span>
          <span v-if="existsAndIsNotEmpty(article.author.title)">{{ article.author.title }}</span>
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    article: {
      type: Object,
      required: true,
    },
    relatedArticle: {
      type: Boolean,
    },
  },
  computed: {
    existsAndIsNotEmpty() {
      return (value) => value !== undefined && value !== null && value !== '' && value !== ' ';
    },
  },
};
</script>

<style scoped>
.article-atom__article-box {
  line-height: 2px;
}
a {
  text-decoration: none;
}
a:hover .article-atom__article-box__title {
  text-decoration: underline;
  color: white;
}
.article-atom img {
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
}
.article-atom__article-box__title {
  margin-top: 10px;
  font-size: 18px;
  letter-spacing: 1.2px;
  font-family: 'fet', sans-serif;
  line-height: 1em;
}
.article-atom__article-box__name {
  font-size: 13px;
  line-height: 1em;
}
.article-atom__article-box__name p,
.article-atom__article-box__name span {
  margin: 0;
  color: #cccccc;
}

@media (max-width: 768px) {
  .related-article .article-atom__article-box__title {
    font-size: 13px;
  }
  .related-article .article-atom__article-box__name {
    font-size: 10px;
  }
}

@media (max-width: 550px) {
  .article-atom {
    display: block;
    padding: 0;
  }
  .article-atom__article-box__title,
  .related-article .article-atom__article-box__title {
    font-size: 15px;
  }
  .article-atom__article-box__name,
  .related-article .article-atom__article-box__name {
    font-size: 13px;
  }
}
</style>
